import React, { useEffect } from "react"
import { useNavigate } from "react-router"

export const ContactPage = () => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/contact")
  })

  return <></>
}
